<template>
  <b-alert v-if="error" variant="danger" show :dismissible="notdismissable === false">
    <i style="color:#a00" class="fas fa-exclamation-circle"></i> {{ error }}
  </b-alert>
</template>

<script>
export default {
  props: ['error', 'notdismissable']
}
</script>
